import { FormattedMessage } from 'react-intl';

import history from 'src/history';

const ExportLimitMessage = () => {
  const handleExportarClick = (event) => {
    event.preventDefault();
    history.push('/ferramentas/exportar');
  };

  return (
    <FormattedMessage
      id="msgLimiteRegistroExportacao"
      values={{
        exportarLink: (chunks) => (
          <a href="/ferramentas/exportar" onClick={handleExportarClick}>
            {chunks}
          </a>
        ),
      }}
    />
  );
};

export default ExportLimitMessage;
